import { tss } from "tss-react/mui"
import { Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconProp } from "@fortawesome/fontawesome-svg-core"

type StyleProps = Readonly<{
    iconBgColor: string
}>

const useStyles = tss.withParams<StyleProps>().create(({ theme: _theme, iconBgColor }) => ({
    noContentContainer: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        justifyContent: "center",
        alignItems: "center",
    },
    noContent: {
        width: "80%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "2rem",
    },
    noContentIcon: {
        fontSize: "2rem",
        width: "4rem",
        height: "4rem",
        borderRadius: "90px",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        backgroundColor: iconBgColor,
    },
    noContentText: {
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignItems: "center",
        gap: "0.5rem",
    },
    noContentHeader: {
        fontWeight: 500,
    },
}))

export type EmptyContentProps = Readonly<{
    icon: IconProp
    backgroundColor: string
    title: string
    description: string
}>

export function EmptyContent({ icon, backgroundColor, title, description }: EmptyContentProps) {
    const { classes } = useStyles({ iconBgColor: backgroundColor })

    return (
        <div className={classes.noContentContainer}>
            <div className={classes.noContent}>
                <div className={classes.noContentIcon}>
                    <FontAwesomeIcon icon={icon} />
                </div>
                <div className={classes.noContentText}>
                    <Typography variant="body1" align="center" className={classes.noContentHeader}>
                        {title}
                    </Typography>
                    <Typography variant="body1" color="textSecondary" align="center">
                        {description}
                    </Typography>
                </div>
            </div>
        </div>
    )
}
